<template>
  <v-sheet
    :class="notop ? 'mx-auto pa-4' : 'mx-auto mt-8 pa-4'"
    style="width: 95%; max-width: 1000px; box-sizing: border-box;"
  >
    <slot></slot>
  </v-sheet>
</template>

<script>
export default {
  props: {
    notop: Boolean
  }
}
</script>
